export function useSendSpeqInivite(location) {
  this.store.dispatch("sendSpeqInvite", location.id).then(resp => {
    this.store.dispatch("getAllLocations");
  });
}